<!--语音输入模板-->
<template>
  <div :class="[isToSpeakIng ? 'voive_wrapper' : 'voive_wrapper']">
    <div class="voice-operate_wrapper" id="operate_wrapper_top">
      <!-- <Button type="primary" @click="handlePlay">播放录音</Button>
         <Button type="primary" @click="handleupdown">下载</Button> -->
      <!-- @click.stop.prevent="touchstart" -->
      <div class="voice-inputCls" @click="touchendClick" :disabled="chatLoading || AutoplayIng"
        :class="[(chatLoading || AutoplayIng) ? 'disabled' : '']">
        <!-- @touchstart.stop.prevent="touchstart"
        @touchmove.stop.prevent="touchmove"
        @touchend.stop.prevent="touchend"
        @touchcancel.stop.prevent="touchend" -->

        <div class="animation ripple">
          <template v-if="isVoiceClick">
            <div class="arc"></div>
            <div class="arc"></div>
            <div class="arc"></div>
          </template>
          <div class="voiceLoad"></div>
        </div>
        <!-- <template v-else>按住 说话</template> -->

        <slot></slot>
      </div>
      <!-- <div class="button">
        <span @click="onChangeInputType(true)">
          <img src="@/assets/img/home/wordBtn.png" alt="切换页面输入方式" />
        </span>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Recorder from "js-audio-recorder";
import { formatDates, intervalTime } from "@/utils/utils";

export default {
  name: "VoiceInputView",
  props: {
    person: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      btnWorld: "",
      // touchTime: 0,
      times: null,
      audioTimes: null,
      tip: "松手发送 上移取消",
      moveIn: false,
      moveClientX: 0,
      moveClientY: 0,
      recorder: {},
      audioRippleData: [],
      numberTime: null,
      number: 100,
      send: false,
      ws: null,
      interval: null,
      progresSseconds: [],
    };
  },
  created() {
    this.recorder = new Recorder({
      sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
      sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
      numChannels: 1, // 声道，支持 1 或 2， 默认是1
      compiling: true, // 支持边录边转换
    });
  },
  computed: {
    ...mapState(["isToSpeakIng", "AutoplayPlayer", "chatData", "chatLoading", "isVoiceClick", "AutoplayIng"]),
    progressShow: function () {
      return function (value) {
        let percentage = (value / 30) * 100;
        return percentage;
      };
    },
    residueTime: function () {
      return function (value) {
        return 30 - Math.round(value);
      };
    },
    touchTime: function () {
      console.log(this.recorder.duration, "--->this.recorder.duration");
      if (this.recorder.duration < 30) {
        return this.recorder.duration;
      } else {
        this.setToSpeakIng(false);
        // this.touchTime = 0;
        return 0;
      }
    },
  },
  methods: {
    ...mapMutations([
      "setToSpeakIng",
      "setChatLoading",
      "contactDisData",
      "setClearTimer",
      "setChatData",
      "updateChatData",
      "setAutoplayIng",
      "setIsVoiceClick",
    ]),
    ...mapActions([
      "sendAudiorecorderAsync",
      "sendAudiorecorder2Async",
      "setMaskDataAsync",
      "deepseekSocket",
    ]),
    onChangeInputType: function () {
      this.$emit("onChangeInputType", false);
      this.setToSpeakIng(false);
      // this.setChatLoading(false);
    },
    useWebSocket() {
      let protocol = location.protocol.includes('https') ? 'wss' : 'wss'
      // let prev = location.protocol.includes('https') ? 'yun.thecover.cn' : 'yun.thecover.cn'
      let prev = location.host.includes('yun.thecover.cn') ? 'yun.thecover.cn' : 'yun.thecover.cn'

      if (this.ws) {
        // this.ws?.close && this.ws?.close()
        // this.ws = null
      }
      // if(!this.ws) {
      this.ws = new WebSocket(`${protocol}://${prev}/famouschat/audioserver/lianghui`);
      this.ws.binaryType = 'arraybuffer'; //传输的是 ArrayBuffer 类型的数据

      this.ws.onopen = () => {
        console.log('连接成功');
      };

      this.ws.onmessage = (msg) => {
        try {
          this.setToSpeakIng(true)
          // this.setChatLoading(true);

          var jsonStr = msg.data;
          var data = JSON.parse(jsonStr);

          // 流式识别语音
          if (data.text) {
            let chat = {
              type: 1,
              text: data.text,
              isLoading: true,
            }
            let newChatData = [...this.chatData]
            let item = newChatData.length ? newChatData[newChatData.length - 1] : {}
            if (data.finish_reason == 1) {
              chat = {
                type: 1,
                text: data.text,
                isLoading: false,
              }
              console.log('chat: ', chat)

              this.setChatLoading(false);
              this.setToSpeakIng(false);
              setTimeout(() => {
                this.deepseekSocket({ payload: { content: chat.text, person: this.person } })

              }, 0)

              // this.ws?.close && this.ws?.close()
              // this.ws = null
            }

            if (item.type == 1) {
              item = chat
              newChatData[newChatData.length - 1] = item
              this.updateChatData(newChatData)
            } else {
              this.setChatData(chat)
            }

          } else {
            if (data.finish_reason == 1) {
              this.setMaskDataAsync({
                type: 10,
                text: "没有听清你的话，请再说一下",
              });
              setTimeout(() => {
                this.setMaskDataAsync(null);
                this.setChatLoading(false);
                this.setToSpeakIng(false);
              }, 1000);
            }
          }

          // 整体识别语音
          // if(data.finish_reason == 1) {
          //   if(data.text) {
          //     let chat = {
          //       type: 1,
          //       text: data.text
          //     }
          //     this.setChatData(chat)
          //     this.deepseekSocket({payload: {content: chat.text}})
          //     this.setChatLoading(false);
          //     this.setToSpeakIng(false);
          //   } else {
          //     this.setMaskDataAsync({
          //       type: 10,
          //       text: "没有听清你的话，请再说一下",
          //     });
          //     setTimeout(() => {
          //       this.setMaskDataAsync(null);
          //       this.setChatLoading(false);
          //       this.setToSpeakIng(false);
          //     }, 1000);
          //   }

          //   // this.ws?.close && this.ws?.close()
          //   // this.ws = null
          // } else {
          //   // this.setChatLoading(true);
          //   if(data.text) {
          //     let chat = {
          //       type: 1,
          //       isLoading: true,
          //     }
          //     let newChatData = [...this.chatData]
          //     let item = newChatData.length ? newChatData[newChatData.length-1] : {}
          //     if(item.type == 1) {
          //       item = chat
          //       newChatData[newChatData.length-1] = item
          //       this.updateChatData(newChatData)
          //     } else {
          //       this.setChatData(chat)
          //     }
          //   }
          // }

        } catch (e) {
          console.log('连接出错: ', e)
        }
      };

      this.ws.onerror = (err) => {
        console.log('连接出错...')
        console.log('err: ', err);
        // let chat = {
        //   type: 1,
        //   text: "没有听清你的话，请再说一下"
        // }
        // this.setChatData(chat)

        this.setMaskDataAsync({
          type: 10,
          text: "没有听清你的话，请再说一下",
        });
        setTimeout(() => {
          this.setMaskDataAsync(null);
        }, 1000);

        this.send = false
        this.setChatLoading(false);
        this.setToSpeakIng(false)
      };

      this.ws.onclose = (msg) => {
        // console.log('关闭连接...')
        // console.log('msg: ', msg)
        this.send = false
      };
      // }
    },
    sendWebsocket(buffer) {
      const end = 'END_SIGNAL';
      const wavDataView = this.recorder.getWAV();
      const base64String = window.btoa(String.fromCharCode(...new Uint8Array(buffer || wavDataView.buffer)))

      if (this.send) {
        this.ws.send(this.stringToBytes(end));
      } else {
        this.ws.send(base64String);
      }
    },
    stringToBytes(val) {
      // create a buffer
      const buff = Buffer.from(val, 'utf-8');
      // encode buffer as Base64
      const base64 = buff.toString('base64');

      return val;
    },
    // 录音  音波图
    drawRecord() {

      // 实时获取音频大小数据
      let dataArray = this.recorder.getRecordAnalyseData(),
        bufferLength = dataArray.length;

      console.log('dataArray: ', dataArray)

      console.log('bufferLength: ', bufferLength)
    },
    touchstart: function (e) {
      let _this = this;
      // this.touchTime = 0;
      _this.moveIn = false;
      _this.recorder.duration = 0;
      _this.recorder.start().then(() => {
        // 开始录音
        this.useWebSocket();

        this.recorder.onprogress = (params) => {
          // console.log('当前录音数据: ', params)
          // this.drawRecord()

          // console.log('parseInt(params.duration): ', parseInt(params.duration))

          // if(progresSseconds.includes(parseInt(params.duration))) {

          // } else {
          //   progresSseconds.push(parseInt(params.duration))
          //   this.sendWebsocket();
          // }

          // if(parseInt(params.duration) == 1) {
          //   this.sendWebsocket();
          // }

          // console.log('this.recorder', this.recorder)

          // console.log('getNextData: ', this.recorder.getNextData())

          if (parseInt(params.duration) > 60) {
            this.touchendClick(e)
            return
          }
          if (this.ws) {
            this.sendWebsocket(this.recorder.getNextData()[0])
          }
        }
      }); // 开始录音
      // 开始录音
      _this.setToSpeakIng(true);
      // 清除自动请求的定时器
      _this.setClearTimer(true);
      _this.moveClientY = e.changedTouches[0].clientY;
      // _this.AutoplayPlayer.pause();

      console.log(this.recorder.duration, "-->this.touchTime888");
    },
    touchmove: function (e) {
      let userClientY = e.changedTouches[0].clientY;
      let operateTop = document.getElementById("operate_wrapper_top");
      let operateTopY = operateTop.getBoundingClientRect().top;
      // 用户在'松开 发送'区域
      if (userClientY > operateTopY) {
        console.log("用户在 松开发送 区域");
        this.recorder.resume(); //继续录音
        this.tip = "松手发送 上移取消";
        this.moveIn = false;
      } else {
        console.log("用户在 取消发送 区域");
        this.recorder.pause(); //暂停录音
        this.moveIn = true;
        clearInterval(this.audioTimes);
        clearInterval(this.times);
        this.times = null;
        this.tip = "手指移入并松开，取消发送";
        // 手指滑动时的坐标位置
        this.moveClientX = e.changedTouches[0].clientX;
        this.moveClientY = e.changedTouches[0].clientY;
      }
    },
    touchend: function () {
      let _this = this;
      // console.log("释放触发");
      clearInterval(this.times);
      this.times = null;

      // 进入开始说话
      this.setToSpeakIng(false);
      // 设置提示信息
      this.tip = "松手发送 上移取消";
      if (_this.number < 120) {
        // 没有开始录音
        _this.clearIntervalNumberTime();
      }

      // console.log(this.recorder, this.recorder.duration, "触发");
      if (this.recorder == null) {
        return false;
      } else {
        // console.log("触发的时间", this.recorder.duration);
        if (this.recorder.duration < 1) {
          // 小于1秒不发送，无论是否移动
          if (!this.moveIn) {
            _this.setMaskDataAsync({
              type: 10,
              text: "语音太短，无法识别",
            });
            _this.recorder.stop();
            setTimeout(() => {
              _this.setMaskDataAsync(null);
            }, 500);
          }
          this.moveIn = false;
          this.recorder.stop();
          // console.log("语音太短，无法识别");
        } else {
          // 触发时间大于1秒
          if (this.moveIn) {
            // 发送上滑动移动 去触发删除按钮
            let deldome = document.getElementById("del_icon_wrapper");
            let minX, minY, maxX, maxY;
            minX = deldome.getBoundingClientRect().left;
            minY = deldome.getBoundingClientRect().top;
            maxX = minX + deldome.offsetWidth;
            maxY = minY + deldome.offsetHeight;
            if (
              this.moveClientX >= minX &&
              this.moveClientX < maxX &&
              this.moveClientY >= minY &&
              this.moveClientY <= maxY
            ) {
              // console.log("触发删除按钮不发送,回到初始状态");
              // this.touchTime = 0;
              this.moveIn = false;
              this.recorder.stop();
            } else {
              // console.log("没有触发删除按钮，直接发送");
              this.sendrecorder();
            }
          } else {
            // console.log("不移动");
            this.sendrecorder();
          }
        }
      }

      //   松开事件
      // 清除定时器
    },

    touchendClick(e) {
      this.$emit("click", false);

      let isVoiceClick = !this.isVoiceClick
      this.setIsVoiceClick(isVoiceClick)

      if (isVoiceClick) {
        this.touchstart(e)
      } else {
        this.touchend(e)
      }
    },


    sendrecorder() {
      this.recorder.stop();
      this.send = true;
      this.sendWebsocket();
      // this.contactDisData([{ content: { right: true, tips: "" } }]);
      this.setChatLoading(true);

      var formData = new FormData();
      var blob = this.recorder.getPCMBlob(); //获取wav格式音频数据
      // l临时测试语音下载
      // this.handlePlay();
      //此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
      var newbolb = new Blob([blob], { type: "audio/pcm" });
      var fileOfBlob = new File([newbolb], new Date().getTime() + ".pcm");

      formData.append("file", fileOfBlob);
      formData.append("type", "input");
      formData.append("questionData", "input");
      // this.sendAudiorecorder2Async({
      //   payload: formData,
      // }).then((data) => {
      //   // 需要走前端模拟按钮点击的逻辑
      //   if (data.length == 1 && data[0].botton !== undefined) {
      //     console.log("需要走前端模拟按钮点击的逻辑");
      //     this.$emit("autoOnBtnAction");
      //   }
      //   _this.setClearTimer(true);
      // });
    },
    handlePlay() {
      // console.log("播放录音");
      this.recorder.play(); // 播放录音
    },
    handleupdown() {
      this.recorder.downloadPCM();
    },
    clearIntervalNumberTime() {
      // console.log("清除长按开启录音的计时器");
      clearInterval(this.numberTime);
      this.number = 100;
    },
  },
  handleDestroy() {
    console.log("销毁实例");
    this.recorder.destroy(); // 毁实例
    this.timer = null;
    clearInterval(this.numberTime);
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/less/common";

.voive_wrapper {
  //   height: 1rem;
  position: relative;

  .hint_wrapper {
    font-size: 0.32rem;
    text-align: center;
    color: #a2a2a2;
    font-family: PingFangSC-Regular;

    .tip_wrapper {
      margin-bottom: 0.17rem;
      text-align: center;
      font-weight: bold;
      font-size: .24rem;
      color: #fff;
      line-height: .35rem;

      &:hover {
        color: #D45547;
      }
    }

    .center {
      width: 7.213333rem;
      height: 2rem;
      margin: 0.9rem auto 0.9rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .voide_fluctuate_wrapper {}

      .residue_wrapper {
        .number {
          width: 1.2rem;
          height: 1.2rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          font-weight: 500;
          font-size: 1.2rem;
          font-family: PingFangSC-Regular;
          color: #db101f;
          margin-right: 0.266667rem;
        }

        .data {
          font-size: 0.453333rem;
          color: #1f1f1f;
          font-family: PingFangSC-Regular;
        }
      }

      .del_wrapper {
        .icon_wrapper {
          width: 2rem;
          height: 2rem;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(219, 16, 31, 0.1);

          img {
            width: 0.666667rem;
            height: 0.8rem;
          }
        }
      }
    }
  }

  .operate_wrapper {
    display: flex;
    justify-content: space-around;
    // padding: 0.1rem 0;
    // margin-top: 0.22rem;
    align-items: center;
    height: .94rem;
    margin: 0 0.24rem;
    padding: 0 .24rem 0 .32rem;
    background: rgba(0, 0, 0, 0.56);
    border-radius: 0.48rem;
    border: 0.02rem solid #FFFFFF;

    .inputCls {
      position: relative;
      background-color: @shadow-color;
      width: 80%;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      text-align: center;
      line-height: .94rem;
      font-size: 0.28rem;
      color: #fff;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-appearance: none;
      background: none;
      border: none;
      outline: none;

      .del_wrapper {
        position: absolute;
        top: 0;
      }

      .del_wrapper:hover {
        color: red;
      }

      .voiceLoad {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        // background: url(../../assets/img/home/voiceLoad.gif) center center / 2.9rem auto no-repeat;
        // background: url(../../assets/img/voiceBtn.png) center center / 1rem auto no-repeat;
      }
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      align-items: center;
      width: 0.48rem;
      height: 0.48rem;
      border-radius: 50%;
      font-size: 0.36rem;
      color: #fff;
      font-weight: 600;
    }
  }
}

.IsToSpeak {
  position: relative;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -0.64rem;
    width: 100%;
    height: 3rem;
    // background: url(../../assets/img/home/voiceBg.png) left top / 100% 100% no-repeat;
    z-index: -1;
  }

  .hint_wrapper {
    // font-size: 0.746667rem;
    // color: #a2a2a2;
    // padding-top: 0.04rem;
    // padding-bottom: 0.166667rem;
  }

  .operate_wrapper {
    background-color: #907861;

    .inputCls {
      // background-color: #ffffff;
      // font-family: PingFangSC-Regular;
      // color: #191919;
    }
  }
}

.voice-operate_wrapper {
  margin: 0 0.35rem;
  text-align: center;
}

.voice-inputCls {
  display: inline-block;

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: .8;
    filter: grayscale(80%);
    /* 将图像完全变为灰色 */
    -webkit-filter: grayscale(80%);
    /* 兼容旧版 Webkit 浏览器 */
  }
}

.animation {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  // border: 3px solid rgba(0, 0, 0, 0.1);
  // animation: rotate 10s linear infinite;
  // animation-play-state: paused;
  // -webkit-animation-play-state: paused;

  .voiceLoad {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    // background: url(../../assets/img/home/voiceLoad.gif) center center / 2.9rem auto no-repeat;
    background: url(../../assets/img/ai-pf/microphone.png) center center / 100% auto no-repeat;
  }
}

// .animation:before {
//   content: "";
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   border: 1px solid #fff;
//   border-radius: 50%;
//   opacity: 0;
//   animation: ripple 2s linear 1s infinite;
//   animation-play-state: paused;
//   -webkit-animation-play-state: paused;
// }

.arc {
  position: absolute;
  top: -0.04rem;
  left: -0.04rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  mask: radial-gradient(transparent 65%, #000 65%);
  -webkit-mask: radial-gradient(transparent 65%, #000 65%);
  // background-image: linear-gradient(transparent 20%, rgba(246,75,73, 1) 30%, transparent 80%);
  background-image: linear-gradient(transparent 30%, #fff 35%, #fff 60%, transparent 65%);
  background-position: 30% 60%;
  background-repeat: no-repeat;

  opacity: 1;
  animation: ripple 2s linear infinite;

  animation-play-state: paused;
  -webkit-animation-play-state: paused;

  // transform: scale(1.25);

  &:nth-child(2) {
    animation: ripple 2s linear .5s infinite;
  }

  &:nth-child(3) {
    animation: ripple 2s linear 1s infinite;
  }
}

// .animation:after {
//   content: "";
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   border: 1px solid #fff;
//   border-radius: 50%;
//   opacity: 0;
//   animation: ripple 2s linear infinite;
//   animation-play-state: paused;
//   -webkit-animation-play-state: paused;
// }
.ripple {
  animation-play-state: running;
  -webkit-animation-play-state: running;

  .arc {
    animation-play-state: running;
    -webkit-animation-play-state: running;
  }
}

.ripple:before {
  animation-play-state: running;
  -webkit-animation-play-state: running;
}

.ripple:after {
  animation-play-state: running;
  -webkit-animation-play-state: running;
}

@keyframes ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  25% {
    transform: scale(1.25);
    opacity: 0.8;
  }

  50% {
    transform: scale(1.5);
    opacity: 0.7;
  }

  75% {
    transform: scale(1.75);
    opacity: 0.6;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
